import React from 'react';
import PropTypes from 'prop-types';
import SignatureBlockFields from './SignatureBlockFields';
import Formsy from 'formsy-react';
import styles from './SignatureBlocks.scss';
import { DthcActions, GlobalNotifications, Intent } from '../../../Modules';

export default class SignatureBlockEditDesktop extends React.Component {
  static propTypes = {
    closeHandler: PropTypes.func.isRequired,
    closeEditor: PropTypes.func,
    commitUpdate: PropTypes.func.isRequired,
    delete: PropTypes.func,
    localSignatureBlock: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    isTemplate: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    isNew: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      submitted: false
    };
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.delete = this.delete.bind(this);
  }

  componentWillUnmount() {
    if (this.props.closeEditor) this.props.closeEditor();
  }

  onValidSubmit() {
    this.setState({ submitted: true });
    this.props.commitUpdate(this.props.index, () => this.props.closeHandler());
  }

  onInvalidSubmit() {
    this.setState({ submitted: true });
    GlobalNotifications.show({
      message: 'Unable to update signature block',
      intent: Intent.DANGER
    });
  }

  reset(e) {
    this.props.reset(this.props.index);
    this.props.closeHandler(e);
    e.stopPropagation();
  }

  delete(e) {
    e.preventDefault();
    this.props.delete(this.props.index, () => this.props.closeHandler);
  }

  render() {
    return (
      <div className={styles.active}>
        <Formsy.Form
          onValidSubmit={this.onValidSubmit}
          onInvalidSubmit={this.onInvalidSubmit}
          style={{ padding: '2em 3em' }}
        >
          <SignatureBlockFields
            localSignatureBlock={this.props.localSignatureBlock}
            onChange={this.props.onChange}
            submitted={this.state.submitted}
            isTemplate={this.props.isTemplate}
          />
          <DthcActions
            reset={this.reset}
            delete={this.delete}
            id={this.props.localSignatureBlock.id}
            isNew={this.props.isNew}
          />
        </Formsy.Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/SignatureBlocks/SignatureBlockEditDesktop.js